import React, {useContext, useState, useEffect, useRef} from "react";
import axios from "../common/axios";
import {BrandContext} from "../common/BrandContext";
import CircularLoader from "../common/CircularLoader";
import Questions from "../questions/Questions";

const WalkthroughsAndQuestions = props => {
    const {hash, callback} = props;
    const [initLoad, setInitLoad] = useState(true);
    const walkthroughsRef = useRef();
    const questionsRef = useRef();
    const brandConfig = useContext(BrandContext);
    const [isLoadingQuestion, setLoadingQuestions] = useState(true);
    const [isLoadingWalkthroughs, setLoadingWalkthroughs] = useState(true);

    useEffect(() => {
        loadWalkthroughs();
        loadQuestions();
        if (callback && typeof callback === 'function') callback();
    }, []);

    useEffect(() => {
        if (!initLoad && callback && typeof callback === 'function') callback();
    }, [hash]);

    const loadWalkthroughs = () => {
        setLoadingWalkthroughs(true);
        axios.get("/lessonSection/loadWalkthroughList.action")
            .then(response => {
                loadHtmlFragment(response.data, walkthroughsRef, () => {
                    setInitLoad(false);
                });
            }).finally(() => {
                setLoadingWalkthroughs(false);
            });
    }

    const loadQuestions = () => {
        setLoadingQuestions(true);
        axios.get("/lessonSection/loadQuestionIndex.action")
            .then(response => {
                loadHtmlFragment(response.data, questionsRef, () => {
                    if (hash && hash.params[0]) window.questions.initQuestions(hash.params[0]);
                });
                // lessonPageRefresh();
                // setupTabGroupUsability();
            }).finally(() => {
                setLoadingQuestions(false);
            });
    }

    const loadHtmlFragment = (html, divRef, callback) => {
        if (divRef.current === undefined) {
            return;
        }

        try {
            const htmlFragment = document.createRange().createContextualFragment(html);
            divRef.current.replaceChildren(htmlFragment);
            if (htmlFragment) {
                if (callback && typeof callback === 'function') callback();
                $(divRef.current).reloadMathJax();
            }
        } catch (e) {
            console.error('Error loading content', e);
            if (typeof newrelic !== 'undefined') {
                newrelic.noticeError('Content error: ' + e);
            }
        }
    }

    return (
        <div className="flex ch-content-walkthrough-questions-wrapper" style={!brandConfig.useDevelopmentNavigation ? {width: "980px"} : null}>
            <div className="ch-lesson-content-two-panel margin-r--s">
                <div className="wq-blk wq-blk-l">
                    <h2>{brandConfig.walkthroughsName}</h2>
                </div>
                <CircularLoader visible={isLoadingWalkthroughs} displayInElement={true}/>
                <div ref={walkthroughsRef} className="js-walkthroughBlk wq-blk wq-blk-l"></div>
            </div>
            <div className="ch-lesson-content-two-panel margin-l--s">
                <div>
                    <h2>Quizzes</h2>
                </div>
                {brandConfig.useReactQuestions ?
                    <Questions /> :
                    <>
                        <CircularLoader visible={isLoadingQuestion} displayInElement={true}/>
                        <div ref={questionsRef} className="js-questionsBlk wq-blk wq-blk-r"></div>
                    </>
                }
            </div>
        </div>
    )
}

export default WalkthroughsAndQuestions;